import {
  AddressBookState,
  deleteAddressBook,
  setAddressBookStore,
} from '@store/customers/customerDetails/addressBookTab';
import { produce } from 'solid-js/store';

export const deleteAddress = async (addressId: string) => {
  try {
    return await deleteAddressBook(addressId);
  } catch (error) {
    setAddressBookStore(
      produce((draft: AddressBookState) => {
        draft.isError = true;
        draft.items = [];
        draft.isLoading = false;
      }),
    );
  }
};
